import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './FpsInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';

const FpsInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ fps, setFps ] = useState<number>(project.encoder.overlayFps);
  const debounce = 100;
  const min = 1;
  const max = 60;

  const onAfterChange = (data: string) => {
    if (project.encoder) { 
      let value = fps;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      setFps(value);

      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          overlayFps: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          overlayFps: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setFps(project.encoder.overlayFps);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.overlayFps]);

  return (
    <div className="fps-input">
      <div className="input-title">{t('producer.inputs.fps.title')}</div>
      <TextInput
        placeholder="producer.inputs.fps.placeholder"
        value={fps.toString()}
        onChange={(value) => {setFps(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.fps.footer')}</div>
    </div>
  );
};

export default React.memo(FpsInput);
